import React, { Component } from "react";
import { observer, inject } from "mobx-react";
import { withRouter } from "react-router-dom";
import { RadioButton, RadioButtonGroup } from 'material-ui/RadioButton';
import { Select } from "./Select";

import HttpClient from 'services/HttpClient';

const SESSION_API = '/api/v1/sessions';

@withRouter
@inject("userStore")
@inject("mcqThemesStore")
@inject("mcqSessionFiltersStore")
@inject('alertStore')
@observer
export class Sessions extends Component {
  startSession = () => {
    const {
      mcqSessionFiltersStore: { theme_ids, filter_type, clearFilters },
      history,
      match,
      alertStore,
    } = this.props;
    const id = match.params.id;

    new HttpClient().post(SESSION_API, {theme_ids, filter_type})
    .then(({ body }) => {
      console.log(body.data.session)
      if (body.data.session.id) {
        history.push(`/exam-prep/${id}/mcq/${body.data.session.id}`);
      }
      clearFilters();
    })
    .catch(() => {
      alertStore.error('Something went wrong. Please try again.');
    });
  };

  render() {
    const {
      mcqThemesStore: { mcq_themes },
      mcqSessionFiltersStore: { theme_ids, setThemes, filter_type, setFilterType, clearFilters },
    } = this.props;
    const themes = mcq_themes.map(theme => ({value: theme.id, title: theme.title}))

    return (
      <div className="mcq-tab">
        <p>Question Filters:</p>
        <div className="mcq-dashboard">
          <Select
            fullWidth
            multiple
            elements={themes}
            value={theme_ids.length > 0 ? theme_ids : ''}
            onChange={(e) => setThemes(e.target.value)}
            floatingLabelText="All Categories"
          />
          <div className="mcq-card mcq-card-row-between">
            <RadioButtonGroup
              name="filter_type"
              className="mcq-filter-type-group"
              defaultSelected={filter_type}
              onChange={(e, newValue) => setFilterType(newValue)}
              valueSelected={filter_type}
            >
              <RadioButton
                value="all_questions"
                label="All Questions"
              />
              <RadioButton
                value="unseen"
                label="Not Seen Before"
              />
              <RadioButton
                value="wrong"
                label="Wrong Before"
              />
            </RadioButtonGroup>
          </div>
        </div>
        <div className="mcq-sessions-buttons">
          <button className="btn-new-main" onClick={this.startSession}>Start session</button>
          <button className="btn-new-white" onClick={() => clearFilters()}>Reset filter</button>
        </div>
      </div>
    );
  }
};



// WEBPACK FOOTER //
// ./src/modules/mcq/components/Sessions.js